<template>
  <v-app>
    <v-main id="signup" :class="{ 'white-bg': $vuetify.breakpoint.smAndDown }">
      <v-container fluid>
        <v-row justify="center" class="mt-9">
          <Logo />
        </v-row>
        <v-row justify="center">
          <v-col cols="12" xs="12" md="4" style="max-width: 400px;">
            <v-card class="card px-2 py-0 elevation-0">
              <MaintenanceCard v-if="maintenance" />

              <v-card-text v-else class="pa-7" :class="{ 'pt-1': $vuetify.breakpoint.smAndDown }">
                <SignError :error="error" />

                <div
                  class="card-title pb-5"
                  :class="{
                    'white--text': $vuetify.theme.dark,
                    'darkTextGrey--text': !$vuetify.theme.dark,
                  }"
                >
                  <p>{{ $t(`views.signup.title`) }}</p>
                </div>

                <SignProviders :loading.sync="loading" />

                <v-form @submit.prevent="submit">
                  <v-text-field
                    v-model="email"
                    autofocus
                    :label="$t('views.login.email.label')"
                    name="email"
                    type="text"
                    :placeholder="$t('views.login.email.placeholder')"
                    :disabled="loading"
                  />
                  <v-text-field
                    id="password"
                    v-model="password"
                    :label="$t('views.login.password.label')"
                    name="password"
                    :placeholder="$t('views.login.password.placeholder')"
                    type="password"
                    :disabled="loading"
                  />
                  <v-text-field
                    id="repeat-password"
                    v-model="repeatPassword"
                    :label="$t('views.forgotReturn.repeatPassword.label')"
                    :placeholder="$t('views.forgotReturn.repeatPassword.placeholder')"
                    name="repeatPassword"
                    type="password"
                    :disabled="loading"
                  />
                  <template>
                    <v-text-field
                      v-model="name"
                      :label="$t('views.signup.name.label')"
                      name="name"
                      type="text"
                      :placeholder="$t('views.signup.name.placeholder')"
                      :disabled="loading"
                    />
                  </template>

                  <div class="mt-0">
                    <v-btn
                      type="submit"
                      color="primary"
                      :loading="loading"
                      :disabled="submitDisabled"
                      class="submit-button elevation-0 mt-2"
                    >
                      {{ $t('views.signup.continue') }}
                    </v-btn>
                  </div>
                </v-form>

                <div class="links mt-7">
                  <v-divider class="pt-4"></v-divider>
                  <a @click="!loading && $router.replace({ name: 'login' })">
                    {{ $t('views.signup.goLogin') }}
                  </a>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-0">
          <LanguageSelector />
        </v-row>
        <v-row justify="center" class="my-5 mr-2">
          <ThemeSelector />
        </v-row>
      </v-container>

      <dashboard-core-footer />
    </v-main>
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
import { createUser } from '@/lib/api.js'
import { get } from 'lodash'
import { mapState } from 'vuex'
import SignMixin from '@/views/components/sign/signMixin.js'
import SignError from '@/views/components/sign/SignError'
import SignProviders from '@/views/components/sign/SignProviders'

export default {
  components: {
    SignError,
    SignProviders,
  },
  mixins: [SignMixin],
  data: () => ({
    email: null,
    password: null,
    repeatPassword: null,
    name: null,
  }),
  computed: {
    ...mapState(['language']),
    submitDisabled() {
      return !this.email || !this.password || !this.name
    },
  },
  methods: {
    async submit() {
      return this.signUp()
    },
    async signUp() {
      if (this.password !== this.repeatPassword) {
        this.error = 'errorRepeat'
        scroll(0, 0)
        return
      }
      this.loading = true
      try {
        // Create user in Firebase
        const response = await firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)

        // Create filios user
        const uid = response.user.uid
        const data = {
          email: this.email,
          name: this.name.toString(),
        }

        const queryReferralCode = get(this, '$route.query.referralCode')
        if (queryReferralCode) data.referralCode = queryReferralCode

        await createUser({ uid, data })

        // Send verification link
        firebase.auth().languageCode = this.language
        await firebase.auth().currentUser.sendEmailVerification()

        await this.login()
      } catch (error) {
        this.error = error.code
        this.loading = false
        scroll(0, 0)
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.white-bg {
  background-color: white !important;
}
.theme--dark {
  .white-bg {
    background-color: #1e1e1e !important;
  }
}
#signup {
  // background: #f9fafc;
  .card {
    text-align: center;
    .items-flex {
      display: flex;
      align-items: center;
    }
    .card-error {
      font-size: 14px;
      font-weight: 300;
    }
    .card-title {
      font-size: 20px;
      font-weight: 300;
    }
    .card-subtitle {
      font-size: 15px;
      font-weight: 300;
      padding-bottom: 20px;
    }
    .submit-button {
      width: 100%;
    }
    .links {
      font-size: 14px;
      font-weight: 300;
      text-decoration: unset;
    }
  }
}
.theme--dark {
  #signup {
    hr {
      border-color: #a5a5a5;
    }
  }
}
</style>
